import React from 'react';
import { BaseCalendar } from './components/BaseCalendar';
import { IPOCard } from './components/MobileCards/IPOCard';
import { createIPOColumns } from './columns/ipoColumns';
import { BaseCalendarPageProps, IPOItem } from './types';
import { applyAllFilters } from './utils/filterUtils';

const IPOCalendarPage: React.FC<BaseCalendarPageProps> = (props) => {
  const columnWidths = [10, 20, 12, 12, 12, 15, 15];

  const transformData = (data: any[]) => {
    try {
      if (!Array.isArray(data)) {
        console.warn('IPO data is not an array:', data);
        return [];
      }

      return data.flatMap((day) => {
        if (!day?.items || !Array.isArray(day.items)) {
          console.warn('Day missing items array:', day);
          return [];
        }

        return day.items.map((item: IPOItem) => ({
          date: item.d || '--',
          company: item.c || '--',
          exchange: item.e || '--',
          actions: item.a || '--',
          shares: item.s || '--',
          priceRange: item.pr || '--',
          marketCap: item.mc || '--',
          ticker: item.t || '--',
        }));
      });
    } catch (error) {
      console.error('Error transforming IPO data:', error);
      return [];
    }
  };

  const filterData = (transformedData: any[], filterOptions: any) => {
    try {
      return applyAllFilters(
        transformedData,
        filterOptions,
        'actions',
        'exchange',
      );
    } catch (error) {
      console.error('Error filtering IPO data:', error);
      return transformedData;
    }
  };

  return (
    <BaseCalendar
      {...props}
      symbol={props?.symbol ?? ''}
      screenType="ipos"
      title="IPOs Calendar"
      columns={createIPOColumns}
      columnWidths={columnWidths}
      mobileCard={IPOCard}
      filterData={filterData}
      transformData={transformData}
      showWatchlistToggle={false}
    />
  );
};

export default IPOCalendarPage;